import { ROUTE_DASHBOARD, ROUTE_SIGN_UP } from '@/constants/routes';
import authService from '@/services/auth.service';
import { RouteObject, redirect } from 'react-router-dom';
import Page from './sign-up.page';

export const routeSignUp: RouteObject = {
  path: ROUTE_SIGN_UP,
  loader() {
    if (authService.isLoggedIn()) {
      return redirect(ROUTE_DASHBOARD);
    }
    return null;
  },
  Component: Page,
};
